/**
 * Confidence Score Component
 * Displays confidence scores as colored chips with hoverable reasoning tooltips
 */

import { Chip, Tooltip, Typography } from '@mui/material';

interface ConfidenceScoreProps {
  score: number;
  reasoning?: string;
}

// Get confidence color based on score thresholds
const getConfidenceColor = (score: number): string => {
  if (score >= 0.7) return '#4caf50'; // Green
  if (score >= 0.4) return '#ff9800'; // Orange
  return '#f44336'; // Red
};

export default function ConfidenceScore({ score, reasoning }: ConfidenceScoreProps) {
  const tooltipContent = reasoning || 'No reasoning given';

  return (
    <Tooltip
      title={
        <Typography
          sx={{
            fontSize: '12px',
            fontStyle: reasoning ? 'normal' : 'italic',
            color: '#000000',
          }}
        >
          {tooltipContent}
        </Typography>
      }
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: '#ffffff',
            color: '#000000',
            border: '1px solid #cccccc',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
        arrow: {
          sx: {
            color: '#ffffff',
            '&::before': {
              border: '1px solid #cccccc',
            },
          },
        },
      }}
    >
      <Chip
        label={`${(score * 100).toFixed(0)}%`}
        size="small"
        sx={{
          bgcolor: getConfidenceColor(score),
          color: 'white',
          fontWeight: 'bold',
          fontSize: '0.75rem',
          cursor: 'help',
        }}
      />
    </Tooltip>
  );
}